import {
  Box,
  Grid,
  HStack,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  Text,
  VStack
} from '@chakra-ui/react';
import React, { FC, useState } from 'react';

import s from '@app/components/Swap/components/TokenSelector/TokenSelector.module.scss';
import { useRouterIntentState } from '@app/state/routerIntentStore';
import { Search } from '@app/components/Search';
import { ListLoader } from '@app/screens/pools/components/ListLoader';
import { getTokensWhitelist } from '@app/constants/tokensWhitelist';
import { useConfig } from '@app/config';
import { useVerifiedPoolsListV3 } from '@app/hooks/pools/useVerifiedPoolsListV3';
import { PoolTokensCell } from '@app/screens/pools/components/PoolTokensCell';
import { BadgesConfig } from '@app/types/pool';
import { Mode } from '@thirdweb-dev/chains';
import { useChainState } from '@app/state/chainStore';

interface Props {
  onClose: () => void;
  isOpen: boolean;
}

export const SelectPoolModal: FC<Props> = ({ onClose, isOpen }) => {
  const {
    targetChainId,
    actions: { setSourceNetwork, setSourceToken, setTargetPool }
  } = useRouterIntentState();
  // const address = useAddress();
  const config = useConfig(targetChainId ?? undefined);
  const [searchTerm, setSearchTerm] = useState('');

  const TOKENS_WHITELIST = getTokensWhitelist(config);

  const { data, isLoading } = useVerifiedPoolsListV3({
    tokens: TOKENS_WHITELIST.map(t => t.contractAddress.toLowerCase())
      .map(token => {
        return `"${token.toLowerCase()}"`;
      })
      .join(','),
    address: undefined,
    orderBy: 'created',
    orderDirection: 'desc',
    search: searchTerm,
    config
  });

  function renderLoader() {
    return (
      <>
        <Skeleton
          height="60px"
          width="100%"
          startColor="neutral.700"
          endColor="neutral.800"
          mb="2px"
        />
        <Skeleton
          height="60px"
          width="100%"
          startColor="neutral.700"
          endColor="neutral.800"
          mb="2px"
        />
        <Skeleton
          height="60px"
          width="100%"
          startColor="neutral.700"
          endColor="neutral.800"
          mb="2px"
        />
      </>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      isCentered
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent sx={{ maxWidth: ['100vw', '600px'] }}>
        <ModalHeader>
          <HStack justify="space-between" px={0} py={0} mb="16px">
            <Text fontSize="16px" color="white" fontWeight="500">
              Select pool
            </Text>
            <ModalCloseButton
              onClick={() => {
                onClose();
              }}
            />
          </HStack>
        </ModalHeader>

        <VStack>
          <Search onSearch={val => setSearchTerm(val)} />
          <Box
            className={s.scrollWrapper}
            id="scrollableDiv"
            overflowY="auto"
            height={400}
            mt={4}
            w="100%"
          >
            {isLoading ? (
              <ListLoader />
            ) : (
              data?.map(item => {
                const badgesView: BadgesConfig | undefined =
                  config?.FLAGS.showBadges?.find(
                    (b: BadgesConfig) =>
                      b.contractAddress.toLowerCase() === item?.id.toLowerCase()
                  );

                return (
                  <Box
                    key={item.id}
                    onClick={() => {
                      setTargetPool(item);
                      setSearchTerm('');
                      onClose();
                    }}
                    sx={{ cursor: 'pointer' }}
                    py="12px"
                    px="12px"
                  >
                    <PoolTokensCell
                      token0={item.token0}
                      token1={item.token1}
                      isMain
                      isNew={badgesView?.new}
                      isVerifiedMeme={badgesView?.verified_meme}
                    />
                  </Box>
                );
              })
            )}
          </Box>
        </VStack>
      </ModalContent>
    </Modal>
  );
};
